import React from 'react'
import styles from './set-age-group.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import AgeGroupSelect from '../../../../age-groups-select/age-groups-select.container'
import { Formik } from 'formik'

const SetAgeGroups = ({
  classes,
  opened,
  requestClose = () => null,
  initialAgeGroup,
  onSubmit
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>Set age group</ModalHeader>
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        ageGroup: initialAgeGroup
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          initialValues
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <AgeGroupSelect
                selectOption={!initialAgeGroup ? 'Select an age group' : null}
                formSelectProps={{
                  value: values.ageGroup,
                  name: 'ageGroup',
                  onChange: handleChange,
                  onBlur: handleBlur
                }}
              />
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button
                disabled={!values.ageGroup || values === initialValues}
                tall
                type="submit">
                Set age group
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(SetAgeGroups)
